import { formatNumber } from "~/format";

export function pluralize(
  num: number,
  singular: string,
  plural: string = `${singular}s`,
) {
  return `${formatNumber(num)} ${num === 1 ? singular : plural}`;
}
